<app-uni-page
  [parent]="this"
  pageTitle="Purchases: EOQ Requirements"
  [bodyTemplate]="bodyTemplate"
  [footerTemplate]="footerTemplate"
>
</app-uni-page>

<ng-template #bodyTemplate>
  <app-ag-grid [gridOptions]="issEOQGridOptions" [rowData]="issEOQs"></app-ag-grid>
  <ng-template #createPoCell let-row>
    <button pButton type="button" class="p-button-text p-button-sm" *ngIf="canCreatePo(row)" (click)="createPo(row)">Create P/O</button>
  </ng-template>
</ng-template>

<ng-template #footerTemplate>
  <div class="left-buttons"></div>
  <div>
    <button pButton type="button" class="p-button-raised" icon="pi pi-arrow-left" (click)="goBack()">
      <span>Go Back</span>
    </button>
  </div>
</ng-template>
